// @flow

import React from 'react';
import type { Node } from 'react';
import ModalContainer from './modalContainer';
import ModalHeader from './modalHeader';
import ModalContent from './modalContent';
import type { TextAlign } from '../../types';

type Props = {
  align?: TextAlign,
  ariaLabel?: string,
  children: Node,
  closeOnOverlayClick: boolean,
  isOpen: boolean,
  onClose: Function,
  size: 'small' | 'medium' | 'large',
  title?: string,
};

const Modal = ({
  align = 'left',
  ariaLabel,
  children,
  closeOnOverlayClick,
  isOpen,
  onClose,
  title,
  size,
}: Props) => (
  <ModalContainer
    align={align}
    ariaLabel={ariaLabel}
    closeOnOverlayClick={closeOnOverlayClick}
    isOpen={isOpen}
    onClose={onClose}
    size={size}
  >
    <ModalHeader
      onClose={onClose}
      title={title}
    />
    <ModalContent>
      {children}
    </ModalContent>
  </ModalContainer>
);

Modal.defaultProps = {
  align: 'left',
  ariaLabel: '',
  title: '',
};

export default Modal;
